import { createAction, props } from '@ngrx/store';
import { ModifaceConfig } from '../networking/models/modiface/modiface-config';

export const getModifaceConfig = createAction(
  '[UI Modiface Config] Modiface Config',
  props<{ data: ModifaceConfig }>()
);